var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-button',{attrs:{"type":"secondary","disabled":!_vm.bot.platformData.googleAssistant.keyFile,"loading":_vm.isLoading},on:{"click":_vm.updateAction}},[_vm._v("Update Action")])
}
var staticRenderFns = []

export { render, staticRenderFns }